import { connect } from 'react-redux';

import { getOfficesList, getOfficesShortList } from '../Offices/officesActions';
// Component
import { getOrganizationMembersList } from '../Projects/projectsActions';
import Evidence from './Evidence';
import { getEvidenceList } from './evidenceActions';

// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  organizationMembersList: state.project.orgMembersList,
  isEvidenceLoading: state.evidence.isEvidenceLoading,
  evidenceList: state.evidence.evidenceList,
  evidenceCount: state.evidence.evidenceCount,
  pageSize: state.evidence.evidenceListPageSize,
  officesList: state.office.officesList,
  isOfficeLoading: state.office.isLoading,
  officesShortList: state.office.officesShortList,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getOrganizationMembersList: params =>
    dispatch(getOrganizationMembersList(params)),
  getOfficesList: params => dispatch(getOfficesList(params)),
  getEvidenceList: details => dispatch(getEvidenceList(details)),
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),

  // setOfficeDetails: params => dispatch(setOfficeDetails(params)),
  //   getPublicZoneList: params => dispatch(getPublicZoneList(params)),
  //   clearOfficeCreatedUpdated: () => dispatch(clearOfficeCreatedUpdated()),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(Evidence);
